import { Button } from "@wags/ui/button.tsx";
import { toast } from "@wags/ui/sonner.tsx";
import {
    GOOGLE_SIGN_IN_START_FAILURE,
    useGoogleSignInStart,
} from "@/lib/core/auth-protocol";
import { withDefaultAuthRedirect } from "./auth-redirect";
import type { ResponsiveSignInOptions } from "./responsive-auth.interface";

export type MobileAuthFormProps = {
    mode?: "sign-in" | "sign-up";
    options?: ResponsiveSignInOptions;
};

export function MobileAuthForm({ mode, options = {} }: MobileAuthFormProps) {
    const googleSignIn = useGoogleSignInStart({
        onFailure: () => toast.error(GOOGLE_SIGN_IN_START_FAILURE),
    });
    return (
        <div className="flex flex-col gap-4 p-card pb-[calc(1rem+env(safe-area-inset-bottom))]">
            <h2 className="text-section-title text-doberman-black">
                {mode === "sign-up" ? "Make Wags yours" : "Welcome back"}
            </h2>
            <p className="text-body text-doberman-black/60">
                Continue with Google to keep your matches and conversations in
                sync.
            </p>
            <Button
                variant="dark"
                size="lg"
                disabled={googleSignIn.pending}
                onClick={() =>
                    void googleSignIn.start(
                        withDefaultAuthRedirect(options).fallbackRedirectUrl,
                    )
                }
            >
                {googleSignIn.pending
                    ? "Opening Google…"
                    : "Continue with Google"}
            </Button>
        </div>
    );
}
